<script setup lang="ts">
import { useModals, type CustomFormElementComponentProps } from '@common';
import { useDecisionSupportWizardStore } from '../../stores/decision-support-wizard.store';

const props = defineProps<CustomFormElementComponentProps>();

const DecisionSupportWizardStore = useDecisionSupportWizardStore();

const modals = useModals();

const applyPrice = () => {
  modals.openConfirm({
    title: 'decisionSupport.wizard.dialog.applyPrice.title',
    text: 'decisionSupport.wizard.dialog.applyPrice.text',
    translate: true,
    onConfirm: async () => {
      if (props.element.name === 'upkeepCost') {
        DecisionSupportWizardStore.applyUnkeepCost(props.element.value);
      } else {
        DecisionSupportWizardStore.applyCropPrice(props.element.value);
      }
    }
  });
};
</script>

<template>
  <div>
    <v-btn
      variant="plain"
      size="sm"
      icon
      :disabled="!element.value"
      @click.prevent.stop="applyPrice">
      <v-tooltip
        location="top"
        :text="$t('button.applyPrice')">
        <template #activator="{ props }">
          <v-icon
            v-bind="props"
            class="d-block position-relative"
            icon="mdi-check">
          </v-icon>
        </template>
      </v-tooltip>
    </v-btn>
  </div>
</template>
